export const styles = theme => ({
  title: {
    marginBottom: `${theme.spacing.unit * 5}px !important`
  },
  chartsRow: {
    marginTop: theme.spacing.unit * 2.75,
    flexGrow: 1,
    paddingLeft: theme.spacing.unit * 0.5,
    paddingRight: theme.spacing.unit * 0.5
  },
  pickedUpShipments: {
    marginRight: theme.spacing.unit * 1.375
  },
  topCarriers: {
    marginLeft: theme.spacing.unit * 1.375
  },
  graphTitle: {
    marginBottom: theme.spacing.unit * 3
  },
  donutGraphs: {
    marginTop: theme.spacing.unit * 7.5
  },

  pickedUpShipmentsGraph: {
    [theme.breakpoints.up('lg')]: {
      marginRight: '2%'
    }
  },
  gridItem: {
    padding: `${theme.spacing.unit * 3}px !important`,
    [theme.breakpoints.up('lg')]: {
      maxWidth: '49%'
    }
  }
});
